import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type CollapseToggleProps = {
  isCollapsed: boolean;
  onToggle: () => void;
};
const CollapseToggle = t0 => {
  const $ = _c(12);
  const {
    isCollapsed,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== onToggle) {
    t1 = e => {
      e.stopPropagation();
      onToggle();
    };
    $[0] = onToggle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cx("absolute -left-10 top-1/2 -translate-y-1/2 z-10", "flex items-center justify-center size-8 rounded-full", "text-quaternary hover:text-secondary hover:bg-hover-control", "transition-all duration-150 cursor-pointer nodrag nopan");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isCollapsed ? "Expand branches" : "Collapse branches";
  let t4;
  if ($[3] !== isCollapsed) {
    t4 = cx("transition-transform duration-150", {
      "-rotate-90": isCollapsed
    });
    $[3] = isCollapsed;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M2 3.5L5 7L8 3.5H2Z" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <svg width="18" height="18" viewBox="0 0 10 10" fill="currentColor" className={t4}>{t5}</svg>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t6) {
    t7 = <button type="button" onClick={t1} className={t2} aria-label={t3}>{t6}</button>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default CollapseToggle;